import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import axios from 'axios';
import api from '../../axiosConfig';
import domain from '../../constants/config.js';

console.log("domain.API_BASE_URL new",domain.API_BASE_URL);
const apiUrl = domain.API_BASE_URL+'v1/my-plan-details';


export const fetchMyPlans = createAsyncThunk(
  'plans/fetchMyPlans',
  async (data) => {
    try {
        console.log("datafetchMyPlans",data);
      const response = await api.post(apiUrl, data);
      return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
);

export const fetchRenewalData = createAsyncThunk(
  'plans/fetchRenewalData',
  async (data) => {
    try {
        console.log("fetchRenewalDatadata",data);
        const apiUrl = domain.API_BASE_URL+'v1/renewal-plan';
        const response = await api.post(apiUrl, data);
        return response.data;
    } catch (error) {
      return error.response?.data || error.message;
    }
  }
);

const myPlanListSlice = createSlice({
  name: 'myPlanList',
  initialState: {
    data:[],
    response: [],
    loading: false, // default false
    error: null,
    renewalData: {} ,
  },
  reducers: {
    setRenewalData: (state, action) => {
      state.renewalData = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyPlans.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
        console.log("fetchMyPlans",state.loading);
      })
      .addCase(fetchMyPlans.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;

      })
      .addCase(fetchMyPlans.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // If it fails → rejected sets error = message
      })
      .addCase(fetchRenewalData.pending, (state) => {
        state.loading = true; // pending is triggered → sets loading = true
        console.log("fetchRenewalData",state.loading);
      })
      .addCase(fetchRenewalData.fulfilled, (state, action) => {
        state.loading = false;
        state.response = action.payload;

      })
      .addCase(fetchRenewalData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message; // If it fails → rejected sets error = message
      });
  },
});

export const { setRenewalData } = myPlanListSlice.actions;
export default myPlanListSlice.reducer;